import { Controller } from '@hotwired/stimulus'
import { useClickOutside } from 'stimulus-use'

export default class extends Controller {
  static targets = ['dropdown']
  static classes = ['opened']

  connect() {
    useClickOutside(this)
  }

  toggle() {
    this.change(this.dropdownTarget.classList.contains(this.openedClass))
  }

  clickOutside() {
    this.change(true)
  }

  change(close = false) {
    if (close) {
      this.dropdownTarget.classList.remove(this.openedClass)
      this.fireEvent('dropdown:close')
    } else {
      this.dropdownTarget.classList.add(this.openedClass)
      this.fireEvent('dropdown:open')
    }
  }

  fireEvent(eventName) {
    this.dropdownTarget.dispatchEvent(new Event(eventName))
  }
}
